import { db, storage } from "./config"
import { collection, addDoc, getDocs, query, where, doc, updateDoc, getDoc } from "firebase/firestore"
import { getDownloadURL, ref, uploadBytes } from "firebase/storage"
import { getAuthHeaders } from "./authHeaders"

// Cloud Functions base URL
const CLOUD_FUNCTIONS_BASE_URL = process.env.REACT_APP_PAYMENT_API || 'http://localhost:5001/card-market-cloud-functions/us-central1/api';

export const createCheckouts = async ({ sessionId, sessionLink, checkoutInfo }) => {
    try {
        // Reference to the "offers" collection
        const offersRef = collection(db, "payments")

        // Add a new document with a generated ID
        const docRef = await addDoc(offersRef, {
            type: 'checkout',
            session_id: sessionId,
            session_link: sessionLink,
            info: checkoutInfo,
            state: 'pending'
        })

        console.log("Document written with ID: ", docRef.id)
    } catch (e) {
        console.error("Error adding document: ", e)
    }
}

export const getWithdrawsByUserId = async (userId) => {
    try {
        const withdrawRef = collection(db, "withdrawals");
        const q = query(withdrawRef, where("userId", "==", userId));
        const querySnapshot = await getDocs(q);

        const withdraws = [];
        querySnapshot.forEach((doc) => {
            withdraws.push({ id: doc.id, ...doc.data() });
        });

        withdraws.sort((a, b) => b.created_at - a.created_at)

        return withdraws; // Returns an array of withdrawal documents
    } catch (e) {
        console.error("Error fetching withdrawals: ", e);
        return []; // Return an empty array on error
    }
}

// Check withdrawal limits for the signed-in user. The server identifies the
// account from the auth token -- the userId argument is kept only so existing
// call sites need no change, and is ignored by the server.
export const checkWithdrawalLimits = async (userId) => {
    try {
        const response = await fetch(`${CLOUD_FUNCTIONS_BASE_URL}/check-withdrawal-limits`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(await getAuthHeaders())
            },
            body: JSON.stringify({
                userId
            })
        });

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error checking withdrawal limits:', error);
        throw error;
    }
};

// Process withdrawal with limits
export const processWithdrawal = async (amount, destination, userId) => {
    try {
        const response = await fetch(`${CLOUD_FUNCTIONS_BASE_URL}/transfer-funds`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(await getAuthHeaders())
            },
            body: JSON.stringify({
                amount,
                destination,
                userId
            })
        });

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error processing withdrawal:', error);
        throw error;
    }
};

// Update account capabilities for existing users
export const updateAccountCapabilities = async (stripeId, returnUrl) => {
    try {
        const response = await fetch(`${CLOUD_FUNCTIONS_BASE_URL}/update-account-capabilities`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(await getAuthHeaders())
            },
            body: JSON.stringify({
                stripeId,
                returnUrl
            })
        });

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error updating account capabilities:', error);
        throw error;
    }
};

// Create withdrawal session and redirect to Stripe
export const createWithdrawalSession = async (amount, userId, returnUrl) => {
    try {
        const response = await fetch(`${CLOUD_FUNCTIONS_BASE_URL}/create-withdrawal-session`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(await getAuthHeaders())
            },
            body: JSON.stringify({
                amount,
                userId,
                returnUrl
            })
        });

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error creating withdrawal session:', error);
        throw error;
    }
};